export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13927.3a8fcab7.jpg";